import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  Box,
  ContentLabelField,
  ContentList,
  FormControlLabel,
  Grid,
  RadioButton,
  RadioGroup,
  Text,
} from '@hopskipdrive/react-components';

export interface AbsentRiderNotificationsProps {
  messagingUpdatesRidersCaregivers?: string;
  editMode: boolean;
}

const SMSAlerts: FC<AbsentRiderNotificationsProps> = ({ messagingUpdatesRidersCaregivers, editMode }) => {
  const { control } = useFormContext();

  return (
    <Box>
      <Grid container>
        <Grid item xs={6}>
          <ContentList mb={4}>
            <Text variant="h3" fontWeight={600}>
              Confirmation, update, and cancellation alerts
            </Text>
          </ContentList>
          <ContentLabelField
            id="messagingUpdatesRidersCaregivers"
            title="Caregiver and Rider"
            description={messagingUpdatesRidersCaregivers === 'Yes' ? 'SMS' : 'No notification'}
            editMode={editMode}
            editView={
              <Controller
                render={({ field: { value, onChange, onBlur } }) => (
                  <RadioGroup value={value} onBlur={onBlur} onChange={onChange} style={{ flexDirection: 'row' }}>
                    <FormControlLabel control={<RadioButton />} label="SMS" value="Yes" />
                    <FormControlLabel control={<RadioButton />} label="No Notification" value="No" />
                  </RadioGroup>
                )}
                name="messagingUpdatesRidersCaregivers"
                control={control}
              />
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SMSAlerts;
